module.exports = __webpack_public_path__ + "static/media/Icon_Moving.ddb82709.png";